import { Scale, styled } from '@secretescapes/falcon';
import { CommonStyledProps } from '@utils/styles.utils';

export const Box = styled('div')<CommonStyledProps>`
  height: ${({ isMobile }) => (isMobile ? `100vh` : ` 100%;`)};
  display: flex;
  gap: ${Scale.m};
  margin-top: ${Scale.l};
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: ${({ isMobile }) => (isMobile ? `${Scale.l}` : `${Scale.xxl} ${Scale.l}`)};
  background: ${({ isMobile, theme }) => (isMobile ? theme.color.white : theme.color.grey05)};
`;

export const CountdownWrapper = styled('span')<CommonStyledProps>`
  width: ${({ isMobile }) => (isMobile ? '100%' : '35%')};
  white-space: normal;
  > p {
    display: inline-flex;
  }
`;
